import axios from 'axios';
import { baseUrl, HttpMethods } from '@/api/base';

import type { IDeleteApplicationAssetService, IGetApplicationAssetsService, IPostApplicationAssetService } from './types';

export async function getApplicationAssets({ params, applicationId }: IGetApplicationAssetsService) {
  const res = await axios.request({
    method: HttpMethods.GET,
    url: `${baseUrl.ROVER}/applications/${applicationId}/assets`,
    params,
  });
  return res.data;
}

export async function deleteApplicationAsset({ assetId, applicationId }: IDeleteApplicationAssetService) {
  const res = await axios.request({
    method: HttpMethods.DELETE,
    url: `${baseUrl.ROVER}/applications/${applicationId}/assets/${assetId}`,
  });
  return res.data;
}

export async function postApplicationAsset({ applicationId, data }: IPostApplicationAssetService) {
  const res = await axios.request({
    method: HttpMethods.POST,
    url: `${baseUrl.ROVER}/applications/${applicationId}/assets/save`,
    data,
  });

  return res.data;
}
